var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.label,"error-messages":_vm.errorMessages,"items":_vm.categories,"item-value":"id","item-text":"name","loading":_vm.isLoading,"return-object":""},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})
}
var staticRenderFns = []

export { render, staticRenderFns }